export default __webpack_public_path__ + "static/media/Roboto-Regular.388de25a.woff2";